import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import LetSBuildYourAiStrategy from "./sections/LetSBuildYourAiStrategy";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <LetSBuildYourAiStrategy />
      <Footer />
    </div>;
}